





































































































































import Vue from 'vue'
import Nav from '@/components/Nav.vue'
import ContactForm from '@/components/ContactForm.vue'
import InvoicesTable from '@/components/InvoicesTable.vue'
import ProjectList from '@/components/Contact/ProjectList.vue'
import BoughtItems from '@/components/Contact/BoughtItems.vue'
import DocumentsList from '@/components/DocumentsList.vue'
import DocumentsUpload from '@/components/DocumentsUpload.vue'
import ContactList from '@/components/ContactList.vue'
import { ApiResponse, Invoice, Contact, Document } from '@/interfaces'
import { mapState } from 'vuex'

interface TabObject {
  _props: Record<string, string>
}

export default Vue.extend({
  components: {
    InvoicesTable,
    Nav,
    ContactForm,
    ProjectList,
    BoughtItems,
    DocumentsList,
    DocumentsUpload,
    ContactList,
  },
  data() {
    return {
      contact: null as Contact | null,
      contactNumber: null as number | null,
      busy: false,
      displayAlert: false,
      userId: '',
      saveContactTrigger: false,
      invoices: [] as Invoice[],
      activeTab: 'infos',
      documents: [] as Document[],
      docToUpdate: null as Document | null,
      itemsTotal: 0,
      addons: 0,
    }
  },
  computed: {
    ...mapState(['user']),
    contactName(): string {
      if (this.contact?.formName) {
        return this.contact?.formName
      } else {
        return ''
      }
    },
    contactTotalSaleAmount(): number {
      if (this.contact?.totalSaleAmount) {
        return this.contact?.totalSaleAmount / 100
      } else {
        return 0
      }
    },
    contactTotalPurchaseAmount(): number {
      if (this.contact?.totalPurchaseAmount) {
        return this.contact?.totalPurchaseAmount / 100
      } else {
        return 0
      }
    },
    contactLcbftState(): number {
      if (this.contact?.lcbftState) {
        return this.contact?.lcbftState
      } else {
        return 0
      }
    },
    contactLastEvaluationEunormat(): string {
      if (this.contact?.lcbftScoreUpdatedAt) {
        const date = new Date(this.contact?.lcbftScoreUpdatedAt)
        return 'Mis à jour par Eunormart le ' + date.toLocaleDateString('fr-FR')
      } else {
        return ''
      }
    },
    itemsTabLabel(): string {
      return `Lots achetés (${this.itemsTotal})`
    },
    tagType(): string {
      switch (this.contact?.lcbftState) {
        case 4:
          return 'danger' // rouge
        case 3:
          return 'warning' // orange
        case 2:
          return 'primary' // bleu
        case 1:
          return 'success' // vert
        default:
          return 'info' // gris par défaut
      }
    },
  },
  watch: {
    user(newVal) {
      this.addons = newVal.client?.addons ?? 0
    },
  },
  mounted() {
    this.userId = this.$route.params.id
    this.displayAlert = false

    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab as string
    }
    this.addons = this.user.client?.addons ?? 0
  },
  methods: {
    addonTest(code: number) {
      if (this.addons == null) {
        return true
      }
      return BigInt(code) & BigInt(this.addons)
    },
    isEunomartConfig() {
      if (this.user.client.config.eunomart) {
        return true
      } else {
        return false
      }
    },
    updateInvoices(invoices: Invoice[]) {
      this.invoices = invoices
    },
    changeTab(tab: TabObject) {
      if (!this.busy) {
        this.activeTab = tab._props.name ?? 'infos'
        // Here we use pushState as using Vue's router would trigger a page reload
        history.pushState(null, '', `${this.$route.path}?tab=${this.activeTab}`)

        this.triggerSave()
      }
      // plus simple : traiter dans le parent le test de l'active tab
      // plutot que le de passer a l'enfant pour qu'il appelle une fonction du
      // parent pour charger la liste des docs
      switch (this.activeTab) {
        case 'documents':
          this.getDocuments()
          break
      }
    },
    triggerSave() {
      this.saveContactTrigger = !this.saveContactTrigger

      return true
    },
    updateContactInfos(contact: Contact) {
      this.contact = contact
      this.contactNumber = contact.contactNumber ?? null
      this.itemsTotal = contact.boughtItemsTotal ?? 0
    },
    getDocuments() {
      if (this.contact?.id !== null) {
        this.$api(`/contact/${this.contact?.id}/documents`).then((response) => {
          const apiResponse = response.data as ApiResponse
          this.documents = apiResponse.data
        })
      }
    },
    updateDocuments(documents: Document[]) {
      // Les appels sur chaque doc ne sont pas sensé renvoyer une liste mais le doc mis à jour
      // l'appel de refresh s'occupe donc de recharger la liste si besoin.
      // appel d'api depuis le composant parent et transmise à composant documentList
      //this.documents = documents
      this.getDocuments()
      // appelé apres upload version corrigée
      // il faut effacer la ref au doc mis à jour (utilisé par DocumentUpload)
      this.docToUpdate = null
    },
    updateDoc(document: Document) {
      this.docToUpdate = document
      ;(this.$refs.uploadDoc as InstanceType<typeof DocumentsUpload>).addFile()
    },
    goBack() {
      this.triggerSave()
      this.routerBack()
    },
    routerBack() {
      this.$router.back()
    },
    reevaluateContact() {
      this.$api.get(`/contact/${this.contact?.id}/updateEunomartEvaluation`)
      /*
        .then(() => {
          const apiResponse = error.response.data as ApiResponse
          this.$notify({
            type: 'success',
            title: 'Succès',
            message: apiResponse.message ?? 'La demande de signature du document a bien été envoyée.',
          })
        })
        .catch((error) => {
          if (error.response) {
            const apiResponse = error.response.data as ApiResponse

            this.$notify({
              type: 'error',
              title: 'Erreur',
              message:
                apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
          }
        })
          */
    },
    eunomartContactLink() {
      if (this.contact?.eunomartId) {
        window.open('https://app.eunomart.com/clients/' + this.contact?.eunomartId, '_blank')
      } else {
        this.$notify({
          type: 'warning',
          title: 'Fiche inextistante',
          message: "Vous devez faire une première demande d'évaluation pour créer le contact sur Eunormart",
        })
      }
    },
    createRequisitionFromContact() {
      const contactId = this.contact?.id
      this.$router.push({
        path: '/requisition/new',
        query: {
          debiteurId: contactId?.toString() ?? '',
          requerantId: contactId?.toString() ?? '',
        },
      })
    },
    createQuickMandat() {
      const contactId = this.contact?.id
      this.$router.push({
        path: '/requisition/new',
        query: {
          debiteurId: contactId?.toString() ?? '',
          requerantId: contactId?.toString() ?? '',
          quickMandat: '1',
        },
      })
    },
    deleteContact(contact: Contact | null) {
      if (!contact?.id) {
        return
      }

      this.$confirm(
        'Êtes-vous sûr(e) de vouloir supprimer ce contact ? Attention, cette opération est irréversible.',
        'Confirmation',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .delete(`/contact/${contact.id}`)
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Succès',
              message: 'Opération réalisée avec succès !',
            })

            this.$router.push({ name: 'contacts' })
          })
          .catch(() => {
            this.$notify({
              type: 'error',
              title: 'Erreur',
              message: 'Une erreur est survenue. Merci de reéssayer plus tard.',
            })
          })
      })
    },
  },
})
